// extracted by mini-css-extract-plugin
export default {"root":"InventoryLicencesModal_root__P37Jn","container":"InventoryLicencesModal_container__UROF8","addBtn":"InventoryLicencesModal_addBtn__oEY6J"};